// src/pages/NovoLancamento.jsx
import { useState } from 'react';
import { getBillKey, getParcelBillKeys, monthLabel, todayStr } from '../services/billing';

export default function NovoLancamento({ cards, addNormal, addParcel, onNavigate }) {
  const [tab, setTab] = useState('simples');
  const [loading, setLoading] = useState(false);

  // Simples
  const [nDesc, setNDesc] = useState('');
  const [nVal, setNVal] = useState('');
  const [nCat, setNCat] = useState('Alimentação');
  const [nCard, setNCard] = useState('');
  const [nDate, setNDate] = useState(todayStr());

  // Parcelado
  const [pDesc, setPDesc] = useState('');
  const [pVal, setPVal] = useState('');
  const [pParc, setPParc] = useState('12');
  const [pCat, setPCat] = useState('Alimentação');
  const [pCard, setPCard] = useState('');
  const [pDate, setPDate] = useState(todayStr());

  const cats = ['Alimentação','Moradia','Transporte','Saúde','Lazer','Educação','Roupas','Outros'];

  function getPreview(cardId, date) {
    if (!cardId || !date || !cards.length) return null;
    const card = cards.find(c => c.id === cardId);
    if (!card) return null;
    const [,, pd] = date.split('-');
    const closeDay = parseInt(card.closeDay);
    const billKey = getBillKey(card, date);
    const sameMonth = parseInt(pd) <= closeDay;
    return { sameMonth, billKey, closeDay, dueDay: card.dueDay };
  }

  const nPreview = getPreview(nCard, nDate);
  const pPreview = getPreview(pCard, pDate);

  async function handleAddNormal(e) {
    e.preventDefault();
    if (!nCard) { alert('Selecione um cartão.'); return; }
    setLoading(true);
    try {
      await addNormal({ desc: nDesc, val: nVal, cat: nCat, cardId: nCard, date: nDate });
      setNDesc(''); setNVal(''); setNDate(todayStr());
      onNavigate('historico');
    } catch (err) { alert('Erro ao salvar. Tente novamente.'); }
    finally { setLoading(false); }
  }

  async function handleAddParcel(e) {
    e.preventDefault();
    if (!pCard) { alert('Selecione um cartão.'); return; }
    if (parseInt(pParc) < 2) { alert('Mínimo 2 parcelas.'); return; }
    setLoading(true);
    try {
      await addParcel({ desc: pDesc, val: pVal, parc: parseInt(pParc), cat: pCat, cardId: pCard, date: pDate });
      setPDesc(''); setPVal(''); setPParc('12'); setPDate(todayStr());
      onNavigate('historico');
    } catch (err) { alert('Erro ao salvar. Tente novamente.'); }
    finally { setLoading(false); }
  }

  function PreviewBox({ preview }) {
    if (!preview) return null;
    const { sameMonth, billKey, closeDay, dueDay } = preview;
    return (
      <div className={`preview-box ${sameMonth ? 'good' : 'next'}`}>
        {sameMonth
          ? <>Dentro do fechamento (dia {closeDay}) → entra na fatura de <strong>{monthLabel(billKey)}</strong>, vence dia <strong>{dueDay}/{monthLabel(billKey).split('/')[1]}</strong>.</>
          : <>Após o fechamento (dia {closeDay}) → vai para a fatura de <strong>{monthLabel(billKey)}</strong>, vence dia <strong>{dueDay}/{monthLabel(billKey).split('/')[1]}</strong>. Você ganha mais tempo para pagar!</>
        }
      </div>
    );
  }

  if (!cards.length) {
    return (
      <div className="content">
        <div className="page-title" style={{ marginBottom: '1rem' }}>Novo lançamento</div>
        <div style={{ color: 'var(--text-3)', fontSize: 13, textAlign: 'center', padding: '3rem', background: 'var(--bg-2)', borderRadius: 'var(--radius-lg)', border: '1px solid var(--border)' }}>
          Você precisa cadastrar um cartão antes de adicionar lançamentos.{' '}
          <span style={{ color: 'var(--accent)', cursor: 'pointer' }} onClick={() => onNavigate('cartoes')}>Cadastrar cartão →</span>
        </div>
      </div>
    );
  }

  return (
    <div className="content">
      <div className="page-header">
        <div className="page-title">Novo lançamento</div>
      </div>

      <div className="tab-row">
        <button className={`tab-btn${tab === 'simples' ? ' active' : ''}`} onClick={() => setTab('simples')}>Gasto simples</button>
        <button className={`tab-btn${tab === 'parcelado' ? ' active' : ''}`} onClick={() => setTab('parcelado')}>Compra parcelada</button>
      </div>

      {tab === 'simples' && (
        <form className="form-box" onSubmit={handleAddNormal}>
          <div className="form-section-label">Gasto simples</div>
          <div className="form-grid form-grid-4">
            <div className="field"><label>Descrição</label><input required placeholder="ex: Supermercado" value={nDesc} onChange={e => setNDesc(e.target.value)} /></div>
            <div className="field"><label>Valor (R$)</label><input required type="number" placeholder="0,00" min="0.01" step="0.01" value={nVal} onChange={e => setNVal(e.target.value)} /></div>
            <div className="field"><label>Categoria</label>
              <select value={nCat} onChange={e => setNCat(e.target.value)}>
                {cats.map(c => <option key={c}>{c}</option>)}
              </select>
            </div>
            <div className="field"><label>Cartão</label>
              <select required value={nCard} onChange={e => setNCard(e.target.value)}>
                <option value="">Selecione...</option>
{cards.filter(c => c.color !== 'cash').map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
{cards.find(c => c.color === 'cash') && (
  <option value={cards.find(c => c.color === 'cash').id}>💵 À vista / Dinheiro</option>)}
              </select>
            </div>
          </div>
          <div className="form-grid form-grid-2">
            <div className="field"><label>Data da compra</label><input required type="date" value={nDate} onChange={e => setNDate(e.target.value)} /></div>
          </div>
          <PreviewBox preview={nPreview} />
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Salvando...' : '+ Adicionar lançamento'}
          </button>
        </form>
      )}

      {tab === 'parcelado' && (
        <form className="form-box" onSubmit={handleAddParcel}>
          <div className="form-section-label">Compra parcelada</div>
          <div className="form-grid form-grid-4">
            <div className="field"><label>Descrição</label><input required placeholder="ex: TV 55&quot;" value={pDesc} onChange={e => setPDesc(e.target.value)} /></div>
            <div className="field"><label>Valor total (R$)</label><input required type="number" placeholder="0,00" min="0.01" step="0.01" value={pVal} onChange={e => setPVal(e.target.value)} /></div>
            <div className="field"><label>Nº de parcelas</label><input required type="number" min="2" max="60" value={pParc} onChange={e => setPParc(e.target.value)} /></div>
            <div className="field"><label>Cartão</label>
              <select required value={pCard} onChange={e => setPCard(e.target.value)}>
                <option value="">Selecione...</option>
                {cards.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>
          </div>
          <div className="form-grid form-grid-2">
            <div className="field"><label>Categoria</label>
              <select value={pCat} onChange={e => setPCat(e.target.value)}>
                {cats.map(c => <option key={c}>{c}</option>)}
              </select>
            </div>
            <div className="field"><label>Data da compra</label><input required type="date" value={pDate} onChange={e => setPDate(e.target.value)} /></div>
          </div>
          {pVal && pParc && parseInt(pParc) >= 2 && (
            <div style={{ fontSize: 12, color: 'var(--text-3)', marginBottom: 12 }}>
              {parseInt(pParc)}x de <strong style={{ color: 'var(--text-1)' }}>R$ {(parseFloat(pVal || 0) / parseInt(pParc || 1)).toFixed(2).replace('.', ',')}</strong>
            </div>
          )}
          <PreviewBox preview={pPreview} />
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Salvando...' : `+ Parcelar compra`}
          </button>
        </form>
      )}
    </div>
  );
}
